import React from 'react';
import { IoIosAlert } from 'react-icons/io';

import { BodyContainer } from '../../sharedStyles';
import { ButtonLink, StyledText, TermItemText, TermSection, TermsTitle } from './sharedComponents';
import Button from '../../../../components/Button/Button';
import ErrorMessage from '../../../../components/ErrorMessage/ErrorMessage';

const UsContent = ({ brandName, isSmall, showConfirm, usState, usStateConfig = {}, errorMessage }: Props) => {
	const [confirm, setConfirm] = React.useState(false);

	return (
		<BodyContainer isSmallScreen={isSmall}>
			<StyledText>
				Should you want to stop betting with us you may close your account. Once closed, you may reactivate your account
				at any time by contacting our customer support team. If you feel you have issues controlling your gambling,
				visit the links below to seek further advice or counseling.
			</StyledText>
			<StyledText>
				To speak with a problem gambling counselor, please call{' '}
				<a href={`tel:${usStateConfig.gamblingPhone}`}>{usStateConfig.gamblingPhoneDisplay}</a> or text{' '}
				<a href={`sms:${usStateConfig.gamblingSMS}`}>{usStateConfig.gamblingSMS}</a>. 
			</StyledText>

			<ButtonLink href={usStateConfig.responsibleGamplingLink}>PlayUp Responsible Gaming Policy</ButtonLink>
			{usState === 'IA' && (
				<>
					<ButtonLink href="https://hhs.iowa.gov/igtp" target="_blank" rel="noopener noreferrer nofollow">
						Iowa Gambling Treatment Program
					</ButtonLink>
					<ButtonLink href="http://www.ncpgambling.org/" rel="noopener noreferrer nofollow">
						National Council on Problem Gambling 
					</ButtonLink>
				</>
			)}

			<TermSection isSmallScreen={isSmall}>
				<TermsTitle>
					<IoIosAlert size={24} style={{ marginRight: 5 }} /> IMPORTANT
				</TermsTitle>
				<TermItemText>• Once activated, account closure will take place immediately.</TermItemText>
				<TermItemText>• Any pending bets will remain active.</TermItemText>
				<TermItemText>
					• If you have a balance, withdraw your funds prior to closure or contact {brandName} customer support.
				</TermItemText>
				<TermItemText>
					• Once your account is closed, you will not receive marketing emails and alerts. Please allow 48 hours for
					these alerts to cease.
				</TermItemText>
			</TermSection>
			<label style={{ display: 'flex', marginBottom: '20px', justifyContent: 'center' }}>
				<input type="checkbox" style={{ marginRight: 5 }} checked={confirm} onChange={() => setConfirm(!confirm)} />{' '}
				<StyledText style={{ margin: 0 }}>
					I understand and accept {brandName}&apos;s{' '}
					<a href={usStateConfig.tcLink} target="_blank" rel="noopener noreferrer nofollow">
						Terms
					</a>
				</StyledText>
			</label>
			{errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
			<Button kind="primary" onClick={showConfirm} disabled={!confirm}>
				Close My Account
			</Button>
		</BodyContainer>
	);
};

export default UsContent;

interface Props {
	brandName: string;
	isSmall: boolean;
	usState?: string;
	usStateConfig?: { [key: string]: any };
	showConfirm: () => void;
	errorMessage?: string;
}
